/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import { BaseAlertCardTaskFragmentDoc } from '../../../../alert-cards-common/src/lib/BaseAlertCard/BaseAlertCard.hook'
import { PrebookingAlertResolveDialogAlertFragmentDoc } from '../../../../alerts-common/src/lib/components/PrebookingAlertResolveDialog/PrebookingAlertResolveDialog.hook'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
import { TripInfoAlertCardStopFragmentDoc } from '../components/TripInfoAlertCard/TripInfoAlertCard.hook'
export type PrebookingAlertCardAlertFragment = {
  __typename: 'TripPrebookingNoAssignment'
  id: string
  status: Types.TaskNotificationStatus
  rejectionAt: string
  notificationType: Types.TaskNotificationType
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  trip: {
    __typename?: 'Trip'
    id: string
    customerV2: {
      __typename?: 'CustomerV2'
      id: string
      givenName: string | null
      familyName: string | null
      phoneNumber: string | null
    }
    pickup: {
      __typename?: 'TripTransferInformation'
      promisedTime: {
        __typename?: 'DateTimeInterval'
        from: string
        to: string
      }
    }
    seatInfo: { __typename?: 'TripSeatInfo'; wheelchairs: number }
  } | null
  resolved: {
    __typename?: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
  } | null
  pickupStop: {
    __typename?: 'Stop'
    id: string
    names: Partial<Record<'de' | 'en' | 'no', string>>
    address: {
      __typename?: 'StopAddress'
      street: string | null
      houseNumber: string | null
      postalCode: string | null
      city: string | null
    }
    routingLocation: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    }
  } | null
  dropoffStop: {
    __typename?: 'Stop'
    id: string
    names: Partial<Record<'de' | 'en' | 'no', string>>
    address: {
      __typename?: 'StopAddress'
      street: string | null
      houseNumber: string | null
      postalCode: string | null
      city: string | null
    }
    routingLocation: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    }
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export const PrebookingAlertCardAlertFragmentDoc = gql`
    fragment PrebookingAlertCardAlert on TripPrebookingNoAssignment {
  id
  status
  rejectionAt
  assigned {
    backofficeUserId
  }
  trip {
    customerV2 {
      id
    }
    pickup {
      promisedTime {
        from
        to
      }
    }
    seatInfo {
      wheelchairs
    }
  }
  resolved {
    initiatedBySystem
  }
  pickupStop {
    ...TripInfoAlertCardStop
  }
  dropoffStop {
    ...TripInfoAlertCardStop
  }
  ...PrebookingAlertResolveDialogAlert
  ...BaseAlertCardTask
}
    ${TripInfoAlertCardStopFragmentDoc}
${PrebookingAlertResolveDialogAlertFragmentDoc}
${BaseAlertCardTaskFragmentDoc}`
